module.exports = __webpack_public_path__ + "img/customerLogo10.7b84cc36.png";